export const APP_VERSION = '3.4.1';
